import backendUrl from "./backendUrl";
export default backendUrl + "/api";
